import template from './project-show.pug';

export const ProjectShowComponent = {
  template,
  bindings: {},
  controller: class ProjectShowComponent {
    constructor(Project, $log, $async, $stateParams, $state) {
      'ngInject';

      this.Project = Project;
      this.$log = $log;
      this.$stateParams = $stateParams;
      this.$state = $state;
      this.getProject = $async(this.getProject.bind(this));
    }

    $onInit() {
      this.getProject();
    }

    async getProject() {
      try {
        this.project = await this.Project.find(this.$stateParams.id);
      } catch (e) {
        this.$log.error(e);
      }
    }

    navigateBack() {
      this.$state.go('main.settings.projects');
    }
  }
};
